import { render } from "./Facebook.vue?vue&type=template&id=6cf7e0e2&scoped=true"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"

import "./Facebook.vue?vue&type=style&index=0&id=6cf7e0e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf7e0e2"]])

export default __exports__